import React, { useMemo } from "react";
import { TouchableOpacity } from "react-native";
import { Icon } from "../../atoms/icon/Icon";
import { style as buttonIconStyle } from "./ButtonIcon.style";
const ACTIVE_OPACITY = 0.6;
const ButtonIcon = ({ name, style: customStyle, testID = "button-icon", onPress, ...restProps }) => {
    const style = useMemo(() => buttonIconStyle(), []);
    return (React.createElement(TouchableOpacity, { activeOpacity: ACTIVE_OPACITY, style: [style.buttonIcon, customStyle?.button], testID: testID, onPress: onPress, ...restProps },
        React.createElement(Icon, { name: name, style: customStyle?.icon })));
};
export { ButtonIcon };
